// packages/ag-charts-locale/src/it-IT.ts
var AG_CHARTS_LOCALE_IT_IT = {
  ariaAnnounceChart: "grafico, ${seriesCount}[number] serie",
  ariaAnnounceFlowProportionLink: "collegamento ${index} di ${count}, da ${from} a ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "nodo ${index} di ${count}, ${description}",
  ariaAnnounceGaugeChart: "grafico a tachimetro, ${caption}",
  ariaAnnounceHierarchyChart: "grafico gerarchico, ${caption}",
  ariaAnnounceHierarchyDatum: "livello ${level}[number], ${count}[number] figli, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Premi Spazio o Invio per attivare/disattivare la visibilit\xE0",
  ariaLabelAddHorizontalLine: "Aggiungi linea orizzontale",
  ariaLabelAnnotationOptionsToolbar: "Opzioni di annotazione",
  ariaLabelAnnotationSettingsDialog: "Impostazioni Annotazioni",
  ariaLabelColorPicker: "Selettore colore",
  ariaLabelFinancialCharts: "Grafici finanziari",
  ariaLabelLegend: "Legenda",
  ariaLabelLegendItem: "${label}, Elemento della leggenda ${index}[number] di ${count}[number]",
  ariaLabelLegendItemUnknown: "Elemento della legenda sconosciuto",
  ariaLabelLegendPageNext: "Prossima pagina della legenda",
  ariaLabelLegendPagePrevious: "Pagina precedente della legenda",
  ariaLabelLegendPagination: "Paginazione della leggenda",
  ariaLabelNavigator: "Navigatore",
  ariaLabelNavigatorMaximum: "Massimo",
  ariaLabelNavigatorMinimum: "Minimo",
  ariaLabelNavigatorRange: "Intervallo",
  ariaLabelRangesToolbar: "Intervalli",
  ariaLabelSettingsTabBar: "Impostazioni",
  ariaLabelZoomToolbar: "Zoom",
  ariaValuePanRange: "${min}[percent0to2dp] a ${max}[percent0to2dp]",
  contextMenuDownload: "Scarica",
  contextMenuPanToCursor: "Sposta qui",
  contextMenuToggleOtherSeries: "Attiva/Disattiva altre serie",
  contextMenuToggleSeriesVisibility: "Attiva/Disattiva Visibilit\xE0",
  contextMenuZoomToCursor: "Zoom qui",
  dialogHeaderChannel: "Canale",
  dialogHeaderDatePriceRange: "Data e Prezzo",
  dialogHeaderDateRange: "Intervallo di date",
  dialogHeaderFibonacciRange: "Ritracciamento di Fibonacci",
  dialogHeaderLine: "Linea",
  dialogHeaderPriceRange: "Intervallo di Prezzo",
  dialogHeaderText: "Testo",
  dialogInputAlign: "Allinea",
  dialogInputColorPicker: "Colore",
  dialogInputColorPickerAltText: "Colore del testo",
  dialogInputExtendAbove: "Estendi sopra",
  dialogInputExtendBelow: "Estendi sotto",
  dialogInputExtendChannelEnd: "Estendi estremit\xE0 del canale",
  dialogInputExtendChannelStart: "Estendi l'inizio del canale",
  dialogInputExtendLeft: "Estendi a sinistra",
  dialogInputExtendLineEnd: "Estendi estremit\xE0 di linea",
  dialogInputExtendLineStart: "Estendi inizio linea",
  dialogInputExtendRight: "Estendi a destra",
  dialogInputFibonacciBands: "Bande",
  dialogInputFibonacciBandsAltText: "Bande di Fibonacci",
  dialogInputFillColorPicker: "Riempimento",
  dialogInputFillColorPickerAltText: "Colore di riempimento",
  dialogInputFontSize: "Dimensione",
  dialogInputFontSizeAltText: "Dimensione del carattere",
  dialogInputLineStyle: "Tratteggiato",
  dialogInputPosition: "Posizione",
  dialogInputReverse: "Inverti",
  dialogInputShowFill: "Mostra riempimento",
  dialogInputStrokeWidth: "Peso",
  dialogInputStrokeWidthAltText: "Peso della Linea",
  iconAltTextAlignCenter: "Centro",
  iconAltTextAlignLeft: "Sinistra",
  iconAltTextAlignRight: "Destra",
  iconAltTextClose: "Chiudi",
  iconAltTextLineStyleDashed: "Linee tratteggiate lunghe",
  iconAltTextLineStyleDotted: "Tratteggiato corto",
  iconAltTextLineStyleSolid: "Solido",
  iconAltTextPositionBottom: "In basso",
  iconAltTextPositionCenter: "Centro",
  iconAltTextPositionTop: "In alto",
  inputTextareaPlaceholder: "Aggiungi testo",
  measurerDateRangeBars: "${value}[number] barre",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Volume ${value}",
  overlayLoadingData: "Caricamento dati...",
  overlayNoData: "Nessun dato da visualizzare",
  overlayNoVisibleSeries: "Nessuna serie visibile",
  overlayUnsupportedBrowser: "Versione del browser non compatibile. Si prega di aggiornare il browser.",
  seriesHistogramTooltipCount: "${yName} (conteggio)",
  seriesHistogramTooltipFrequency: "Frequenza",
  seriesHistogramTooltipMean: "${yName} (media)",
  seriesHistogramTooltipSum: "${yName} (somma)",
  toolbarAnnotationsArrow: "Freccia",
  toolbarAnnotationsArrowDown: "Freccia Gi\xF9",
  toolbarAnnotationsArrowUp: "Freccia Su",
  toolbarAnnotationsCallout: "Annotazione",
  toolbarAnnotationsClearAll: "Cancella Tutto",
  toolbarAnnotationsComment: "Commento",
  toolbarAnnotationsDatePriceRange: "Data e Prezzo",
  toolbarAnnotationsDateRange: "Intervallo di date",
  toolbarAnnotationsDelete: "Elimina",
  toolbarAnnotationsDisjointChannel: "Canale Disgiunto",
  toolbarAnnotationsDragHandle: "Trascina la Barra degli Strumenti",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Ritracciamento di Fibonacci",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Basato su Tendenza",
  toolbarAnnotationsFillColor: "Colore di Riempimento",
  toolbarAnnotationsHorizontalLine: "Linea Orizzontale",
  toolbarAnnotationsLineAnnotations: "Linee di tendenza",
  toolbarAnnotationsLineColor: "Colore della linea",
  toolbarAnnotationsLineStrokeWidth: "Spessore tratto linea",
  toolbarAnnotationsLineStyle: "Stile della linea",
  toolbarAnnotationsLock: "Blocca",
  toolbarAnnotationsMeasurerAnnotations: "Misuratori",
  toolbarAnnotationsNote: "Nota",
  toolbarAnnotationsParallelChannel: "Canale parallelo",
  toolbarAnnotationsPriceRange: "Intervallo di Prezzo",
  toolbarAnnotationsQuickDatePriceRange: "Misura",
  toolbarAnnotationsSettings: "Impostazioni",
  toolbarAnnotationsShapeAnnotations: "Frecce",
  toolbarAnnotationsText: "Testo",
  toolbarAnnotationsTextAnnotations: "Annotazioni di testo",
  toolbarAnnotationsTextColor: "Colore del testo",
  toolbarAnnotationsTextSize: "Dimensione del testo",
  toolbarAnnotationsTrendLine: "Linea di tendenza",
  toolbarAnnotationsUnlock: "Sblocca",
  toolbarAnnotationsVerticalLine: "Linea Verticale",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 mese",
  toolbarRange1Year: "1A",
  toolbarRange1YearAria: "1 anno",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 mesi",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 mesi",
  toolbarRangeAll: "Tutti",
  toolbarRangeAllAria: "Tutto",
  toolbarRangeYearToDate: "Da Inizio Anno",
  toolbarRangeYearToDateAria: "Anno fino ad oggi",
  toolbarSeriesTypeCandles: "Candele",
  toolbarSeriesTypeDropdown: "Tipo di grafico",
  toolbarSeriesTypeHighLow: "Massimo Minimo",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Candele Vuote",
  toolbarSeriesTypeLine: "Linea",
  toolbarSeriesTypeLineWithMarkers: "Linea con Marcatori",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Linea a Passi",
  toolbarZoomPanEnd: "Dalla fine",
  toolbarZoomPanLeft: "Sposta a sinistra",
  toolbarZoomPanRight: "Sposta a destra",
  toolbarZoomPanStart: "Panoramica all'inizio",
  toolbarZoomReset: "Reimposta lo zoom",
  toolbarZoomZoomIn: "Ingrandisci",
  toolbarZoomZoomOut: "Riduci lo zoom",
  tooltipPaginationStatus: "${index}[number] di ${count}[number]"
};
export {
  AG_CHARTS_LOCALE_IT_IT
};
//# sourceMappingURL=it-IT.esm.mjs.map
